import api from "@helpers/api";

import { PaginationRequestType } from "@type/HRM/pagination";
import { PunishmentsResponseType } from "@type/HRM/punishments";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}`;

export const getPunishments = (() => {
  return async (
    data: PaginationRequestType,
  ): Promise<PunishmentsResponseType> => {
    const {
      page,
      search,
      dateOrder,
      startDate,
      endDate,
      officeId,
      positionId,
      unitId,
    } = data.payload;
    return api
      .get(`${apiEndPoint}/discipline-infos`, {
        params: {
          page,
          size: 10,
          search,
          dateOrder,
          startDate,
          endDate,
          officeId,
          positionId,
          unitId,
        },
      })
      .then((response) => {
        const { data, page, size, total } = response.data;
        return {
          data,
          pagination: {
            page,
            size,
            total,
          },
        };
      });
  };
})();
